import {LoginForm} from '@coolcolduk/ui-login';
import {Typography} from '@mui/material';
import {browserPopupRedirectResolver, GoogleAuthProvider, signInWithPopup} from 'firebase/auth';
import {firebaseAuth} from '../../setup/firebase';

export const signInWithGoogle = async () => {
  const provider = new GoogleAuthProvider();
  try {
    await signInWithPopup(firebaseAuth, provider, browserPopupRedirectResolver);
  } catch (error) {
    console.error('Error signing in with Google:', error);
  }
};

const heading = () => (
  <Typography variant="h3" sx={{marginBottom: 3}}>
    Login/Signup
  </Typography>
);

export default function LoginPage() {
  return <LoginForm onGoogleClick={signInWithGoogle} HeaderComponent={heading} />;
}
